import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";
import { AssistanceSection, BenefitSection, BoostSection, FAQ, LargeData } from '../../Data/All_Services_Data/accountingData';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';

const AccountingAndBookkeepingServices = () => {
    useMetaTags({
      title: "Professional Accounting & Bookkeeping Solutions",
      description:
        "Trusted accounting and bookkeeping solutions to streamline your finances with expert solutions tailored to your business",
      keywords:
        "accounting and bookkeeping services, bookkeeping services, accounting and bookkeeping, accounting services,  Accounting & Bookkeeping Solutions, accounting and bookkeeping services, accounting bookkeeping, accounting firm, financial accounting, accounting packages",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Professional Accounting & Bookkeeping Solutions
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }
          
        .my_space{
            padding: 20px;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/accountandbook.jpg"
                  loading="lazy"
                  alt="heading_image"
                />
                <p>
                  At our company we present to you a range of professional
                  accounting and bookkeeping solutions which we tailor for
                  companies globally. We bring to the table in-depth
                  knowledge of financial systems and compliance which we use to
                  help our clients keep accurate records, make better financial
                  decisions, and also to ensure full HMRC compliance. Our team
                  is made up of professionals that have years of experience
                  which they bring forward as we integrate the best technology
                  out there to improve every aspect of your financial processes.
                  Whether you run a small business or are part of a growing
                  enterprise our expertise is at your service. We take pride in
                  what we do, which is to build long term relationships based on
                  quality service and open communication. Our mission is to make
                  accounting and bookkeeping as easy as possible for you.
                </p>
              </div>
              {/* Accounting and Bookkeeping services */}
              <Handle_Largedata_section LargeData={LargeData} />

              {/* Benefits of Accounting or Bookkeeping */}
              <Benefits_section data={BenefitSection} />

              {/* Hire accounting  */}
              <Assistance_section data={AssistanceSection} />

              {/* Conclusion  */}
              {/* <Boost_section data={BoostSection} /> */}

              <div className="my_space"></div>

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default AccountingAndBookkeepingServices;